$(document).ready(function (e) {
  $("#modal-thankyoualert .Modal__Close").click(function () {
    window.location.href = "/account";
  });
  let getUrlParameter = function getUrlParameter(sParam) {
    let sPageURL = window.location.search.substring(1),
      sURLletiables = sPageURL.split("&"),
      sParameterName,
      i;
    for (i = 0; i < sURLletiables.length; i++) {
      sParameterName = sURLletiables[i].split("=");
      if (sParameterName[0] === sParam) {
        return typeof sParameterName[1] === undefined
          ? true
          : decodeURIComponent(sParameterName[1]);
      }
    }
    return false;
  };
  let orderurl = getUrlParameter("order");
  let emailurl = getUrlParameter("email");
  if (orderurl) {
    $("input[name=ordernumber]").val(orderurl);
  }
  if (emailurl) {
    $("input[name=email]").val(emailurl);
  }

  $("#returnform").on("submit", function (e) {
    e.preventDefault();
    let returnorderno = $("input[name=ordernumber]").val();
    let returnemail = $("input[name=email]").val();
    $.ajax({
      type: "POST",
      url: "https://marigoldlife.mojitolabs.com/verify.php",
      data: new FormData(this),
      contentType: false,
      cache: false,
      processData: false,
      beforeSend: function () {
        $("#loadingkeys").css("display", "block");
        $(".sub").attr("disabled", "disabled");
        $("#returnform").css("opacity", ".5");
      },
      success: function (msg) {
        $("#loadingkeys").css("display", "none");
        $("#returnform")[0].reset();
        $("#returnform").css("opacity", "");
        $(".sub").removeAttr("disabled");

        $.cookie("returnorderno", returnorderno, { path: "/" });
        $.cookie("returnemail", returnemail, { path: "/" });

        if (msg != "Return Request Invalid Or Return Already Done") {
          $(".responseerr").html("");
          $("p.title_head").html("Select the item & share details below");
          $("div#screenone").css("display", "none");
          $("div#screentwo").css("display", "block");
          let rescookiearray = JSON.parse(msg);

          $("div#screentwo #datas #screentwoform").html(
            "<div class='TableWrapper'><table class='AccountTable Table Table--large'><thead class='Text--subdued'><tr><th></th><th>Image</th><th>Product Name</th><th class='Text--alignRight'>Select Option/Reason</th></tr></thead><tbody class='Heading u-h7'><tr></tr></tbody></table</div>"
          );

          jQuery.each(rescookiearray, function (index, value) {
            let rowstring = "";
            let k = 0;
            jQuery.each(value, function (key, i) {
              if (k === 0) {
                rowstring +=
                  "<td><input type='checkbox' class='productcheckbox' name='rowcheck[]' value='" +
                  i +
                  "'></td>";
              } else if (k === 1) {
                rowstring += "<td><img src='" + i + "' class='proimg'></td>";
              } else if (k === 3) {
                rowstring +=
                  "<td><select class='Form__Input mainbox hideclass' name='" +
                  i +
                  "'><option value='Cancellation' selected>Cancellation</option></select><select class='Form__Input childbox " +
                  i +
                  "' name='Cancellation-" +
                  i +
                  "'><option selected='' disabled='' value=''>Select Reason</option><option value='Changed my mind'>Changed my mind</option><option value='Placed order/duplicate order by mistake'>Placed order/duplicate order by mistake</option><option value='Found cheaper elsewhere'>Found cheaper elsewhere</option><option value='Expected early delivery'>Expected early delivery</option><option value='Need to change mode of payment'>Need to change mode of payment</option><option value='Others'>Others- Pls specify</option> </select><input type='text' class='Form__Input otherreasonbox hideclass' id='otherreasonbox_" +
                  i +
                  "' placeholder='Pls specify the concern'></td>";
              } else {
                rowstring += "<td style='width:40%'>" + i + "</td>";
              }
              k++;
            });

            $(
              "div#screentwo #datas #screentwoform .TableWrapper table.AccountTable tbody.Heading.u-h7"
            ).append("<tr>" + rowstring + "</tr>");
          });

          $("div#screentwo #datas #screentwoform").append(
            '<div class="footersection"><input type="hidden" name="returnorder" value="' +
              returnorderno +
              '"><input type="hidden" name="returnemail" value="' +
              returnemail +
              '"><button type="submit" id="returnreqscreen2" name="returnreqscreen2" class="Form__Submit Button Button--primary Button--full sub">Submit Request</button></div>'
          );
          //select required
          $("select.mainbox").on("change", function () {
            let selectname = $(this).attr("name");
            let selectvalue = $(this).val();
            $("select.childbox." + selectname)
              .addClass("hideclass")
              .prop("required", false);
            $("#otherreasonbox_" + selectname)
              .removeAttr("name")
              .addClass("hideclass")
              .prop("required", false);
            $("#exchangesizebox_" + selectname)
              .removeAttr("name")
              .addClass("hideclass")
              .prop("required", false);

            let subselectvale = selectvalue + "-" + selectname;
            $("select[name=" + subselectvale + "]")
              .removeClass("hideclass")
              .prop("required", true);
          });
          $("select.childbox").on("change", function () {
            let selectnamechild = $(this).attr("name");
            let selectvaluechild = $(this).val();
            let otherboxname = "Other-" + selectnamechild;
            let otherreasonid = selectnamechild
              .replace("Return-", "")
              .replace("Exchange-", "")
              .replace("Cancellation-", "")
              .replace("Alteration-", "");
            let exchangesizeboxname = "exchangesize-" + selectnamechild;
            if (selectvaluechild == "Others") {
              $("#otherreasonbox_" + otherreasonid)
                .attr("name", otherboxname)
                .removeClass("hideclass")
                .prop("required", true);
            } else {
              $("#otherreasonbox_" + otherreasonid)
                .removeAttr("name")
                .addClass("hideclass")
                .prop("required", false);
            }
            if (selectnamechild.indexOf("Exchange") != -1) {
              if (
                selectvaluechild == "Size is too big" ||
                selectvaluechild == "Size is too small"
              ) {
                $("#exchangesizebox_" + otherreasonid)
                  .attr("name", exchangesizeboxname)
                  .removeClass("hideclass")
                  .prop("required", true);
              } else {
                $("#exchangesizebox_" + otherreasonid)
                  .removeAttr("name")
                  .addClass("hideclass")
                  .prop("required", false);
              }
            } else {
              $("#exchangesizebox_" + otherreasonid)
                .removeAttr("name")
                .addClass("hideclass")
                .prop("required", false);
            }
          });

          $("form#screentwoform div.TableWrapper .productcheckbox").click(
            function () {
              let valuecheckbox = $(this).val();
              if ($(this).is(":checked")) {
                $("select[name=reason-" + valuecheckbox + "]").prop(
                  "required",
                  true
                );
              } else {
                $("select[name=reason-" + valuecheckbox + "]").prop(
                  "required",
                  false
                );
              }
            }
          );
          //
        } else {
          $(".responseerr").html(
            "<p>Your cancellation request for this order has already been received, our team will get in touch with you.</p> <p>If you want to place another request, please enter details below :-</p>"
          );
        }
      },
    });
  });
  if (orderurl && emailurl) {
    $("#returnverify").trigger("click");
  }
  // screen 2

  $("#screentwoform").on("submit", function (e) {
    e.preventDefault();
    let checked = $("input[type=checkbox]:checked").length;
    if (!checked) {
      $("p#itemcheckboxerr").html("You must select at least one item.");
      return false;
    } else {
      $("p#itemcheckboxerr").html("");
    }
    $.ajax({
      type: "POST",
      url: "https://marigoldlife.mojitolabs.com/reasonsave.php",
      data: new FormData(this),
      contentType: false,
      cache: false,
      processData: false,
      beforeSend: function () {
        $("#loadingkeys").css("display", "block");
        $(".sub").attr("disabled", "disabled");
        $("#screentwoform").css("opacity", ".5");
      },
      success: function (msg) {
        $("p.title_head").html(
          "Please enter order ID and email ID for verification"
        );
        $("#loadingkeys").css("display", "none");
        $("#screentwoform")[0].reset();
        $("#screentwoform").css("opacity", "");
        $(".sub").removeAttr("disabled");
        $("div#screentwo").css("display", "none");
        $("div#screenone").css("display", "block");
        $("#toopenthanks")[0].click();
        $.removeCookie("returnemail", { path: "/" });
        $.removeCookie("returnorderno", { path: "/" });
      },
    });
  });
});
